import { getColumnNameFromGeoColumn, getSpatialIndexFromGeoColumn } from 'features/builder/state/builderSliceUtils'
import { formatSource } from '../../utils'

export const generateCreateTableFromQuery = ({ output, query, geoColumn }) => {
  const formattedOutput = formatSource(output)
  const geoColumnName = getColumnNameFromGeoColumn(geoColumn)
  const spatialIndex = getSpatialIndexFromGeoColumn(geoColumn)

  if (spatialIndex) {
    return `
    CREATE TABLE ${formattedOutput} CLUSTER BY (${geoColumnName}) AS (
      ${query}
    )
  `
  }
  return `
    CREATE TABLE ${formattedOutput} AS (SELECT * FROM (
      ${query}
    ) ORDER BY ST_XMIN(geom), ST_YMIN(geom))
  `
}
